import Tooltip from '@anm/components/Tooltip';
import { InfoLabel } from '@anm/styles/helpers';
import { useCallback, useRef, FC } from 'react';
import { useSelector } from 'react-redux';

import { CHART_BAR_MARGIN_RIGHT } from '..';
import { analyticsSelectors } from '../../../../../../store/modules/analytics';
import { projectSelectors } from '../../../../../../store/modules/project';
import { ChartTitle, ChartTitleWrapper, TitleRow } from '../Wrapper';
import { useHeaderMaxWidth } from '../hooks';
import { AnalyticsTabProps } from '../types';

import Content from './Content';

const UniquePlaysChart: FC<AnalyticsTabProps> = props => {
  const uniquePlaysChartRef = useRef<HTMLDivElement>(null);
  const totalPlays = useSelector(state =>
    analyticsSelectors.selectAggregateValueByKey(state, 'plays')
  );

  const isProjectEverRender = useSelector(
    projectSelectors.selectCurrentProjectEverRendered
  );

  const containerWidth = useHeaderMaxWidth(
    uniquePlaysChartRef,
    CHART_BAR_MARGIN_RIGHT
  );
  const renderTooltipContent = useCallback(
    () => <span>Number of individual viewers.</span>,
    []
  );

  return (
    <div ref={uniquePlaysChartRef}>
      <TitleRow maxWidth={containerWidth}>
        <ChartTitleWrapper>
          <ChartTitle title={`Unique plays`} level={4} />
          <Tooltip direction="to-top" renderContent={renderTooltipContent}>
            <InfoLabel />
          </Tooltip>
        </ChartTitleWrapper>
        {isProjectEverRender && <span>{totalPlays}</span>}
      </TitleRow>
      <Content
        maxWidth={containerWidth}
        containerRef={uniquePlaysChartRef}
        {...props}
      />
    </div>
  );
};

export default UniquePlaysChart;
